module.exports = __webpack_public_path__ + "static/media/dead-dark.e18aa261.png";